






import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import * as Y from 'yjs'
import MarkdownViewer from 'components/MarkdownViewer.vue'
import { SlideParamsValuesSet } from 'src/assets/AttendeeItemData'

@Component({
  components: {
    MarkdownViewer
  }
})
export default class MarkdownViewerCrdt extends Vue {
  value = ''

  @Prop()
  readonly text!: Y.Text

  @Prop({ type: Object, default: () => { return {} } })
  readonly params!: SlideParamsValuesSet

  @Watch('text', { immediate: true })
  initText (text: Y.Text | undefined, prev: Y.Text | undefined) {
    prev?.unobserve(this.observer)
    text?.observe(this.observer)
    this.parametrize(text?.toString() || '', this.params)
  }

  @Watch('params')
  initParams(params: SlideParamsValuesSet) {
    this.parametrize(this.text?.toString() || '', params)
  }

  observer (event: Y.YTextEvent, transaction: Y.Transaction) {
    this.parametrize(this.text.toString(), this.params)
  }

  parametrize (text: string, params: SlideParamsValuesSet) {
    this.value = text.replace(/(\[\[[^\]]*\]\])/g, (x) => {
      const name = x.substr(2, x.length - 4)
      return params[ name ] === '' || params[ name ] === undefined ? x : '' + params[ name ]
    })
  }
}
